import { isAfter, isBefore } from "date-fns/fp";
import { defu } from "defu";
import * as v from "valibot";
import { err, fromThrowable, ok } from "neverthrow";

//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) {
		__defProp(target, name, {
			get: all[name],
			enumerable: true
		});
	}
	if (!no_symbols) {
		__defProp(target, Symbol.toStringTag, { value: "Module" });
	}
	return target;
};

//#endregion
//#region src/claimAdapter/refData/medicareProvSupplierDesc.ts
const medicareProvSupplierDesc = {
	"1": "Physician/General Practice",
	"2": "Physician/General Surgery",
	"3": "Physician/Allergy/ Immunology",
	"4": "Physician/Otolaryngology",
	"5": "Physician/Anesthesiology",
	"6": "Physician/Cardiovascular Disease (Cardiology)",
	"7": "Physician/Dermatology",
	"8": "Physician/Family Practice",
	"9": "Physician/Interventional Pain Management",
	"10": "Physician/Gastroenterology",
	"11": "Physician/Internal Medicine",
	"12": "Physician/Osteopathic Manipulative Medicine",
	"13": "Physician/Neurology",
	"14": "Physician/Neurosurgery",
	"15": "Speech Language Pathologist",
	"16": "Physician/Obstetrics & Gynecology",
	"17": "Physician/Hospice and Palliative Care",
	"18": "Physician/Ophthalmology",
	"19": "Physician/Ophthalmology",
	"20": "Physician/Orthopedic Surgery",
	"21": "Clinical Cardiac Electrophysiology",
	"22": "Physician/Pathology",
	"23": "Physician/Sports Medicine",
	"24": "Physician/Plastic and Reconstructive Surgery",
	"25": "Physician/Physical Medicine and Rehabilitation",
	"26": "Physician/Psychiatry",
	"27": "Physician/Geriatric Psychiatry",
	"28": "Physician/Colorectal Surgery (Proctology)",
	"29": "Physician/Pulmonary Disease",
	"30": "Physician/Diagnostic Radiology",
	"31": "Intensive Cardiac Rehabilitation",
	"32": "Anesthesiology Assistant",
	"33": "Physician/Thoracic Surgery",
	"34": "Physician/Urology",
	"35": "Chiropractic",
	"36": "Physician/Nuclear Medicine",
	"37": "Physician/Pediatric Medicine",
	"38": "Physician/Geriatric Medicine",
	"39": "Physician/Nephrology",
	"40": "Physician/Hand Surgery",
	"41": "Optometry",
	"42": "Certified Nurse Midwife",
	"43": "Certified Registered Nurse Anesthetist (CRNA)",
	"44": "Physician/Infectious Disease",
	"45": "Mammography Center",
	"46": "Physician/Endocrinology",
	"47": "Independent Diagnostic Testing Facility (IDTF)",
	"48": "Podiatry",
	"49": "Ambulatory Surgical Center",
	"50": "Nurse Practitioner",
	"51": "Medical Supply Company with Orthotist",
	"52": "Medical Supply Company with Prosthetist",
	"53": "Medical Supply Company with Orthotist-Prosthetist",
	"54": "Other Medical Supply Company",
	"55": "Individual Certified Orthotist",
	"56": "Individual Certified Prosthetist",
	"57": "Individual Certified Prosthetist-Orthotist",
	"58": "Medical Supply Company with Pharmacist",
	"59": "Ambulance Service Provider",
	"60": "Public Health or Welfare Agency",
	"61": "Voluntary Health or Charitable Agency",
	"62": "Psychologist, Clinical",
	"63": "Portable X-Ray Supplier",
	"64": "Audiologist",
	"65": "Physical Therapist in Private Practice",
	"66": "Physician/Rheumatology",
	"67": "Occupational Therapist in Private Practice",
	"68": "Psychologist, Clinical",
	"69": "Clinical Laboratory",
	"70": "Clinic or Group Practice",
	"71": "Registered Dietitian or Nutrition Professional",
	"72": "Physician/Pain Management",
	"73": "Mass Immunizer Roster Biller",
	"74": "Radiation Therapy Center",
	"75": "Slide Preparation Facility",
	"76": "Physician/Peripheral Vascular Disease",
	"77": "Physician/Vascular Surgery",
	"78": "Physician/Cardiac Surgery",
	"79": "Physician/Addiction Medicine",
	"80": "Licensed Clinical Social Worker",
	"81": "Physician/Critical Care (Intensivists)",
	"82": "Physician/Hematology",
	"83": "Physician/Hematology-Oncology",
	"84": "Physician/Preventive Medicine",
	"85": "Physician/Maxillofacial Surgery",
	"86": "Physician/Neuropsychiatry",
	"87": "All Other Suppliers",
	"88": "Unknown Supplier/Provider Specialty",
	"89": "Certified Clinical Nurse Specialist",
	"90": "Physician/Medical Oncology",
	"91": "Physician/Surgical Oncology",
	"92": "Physician/Radiation Oncology",
	"93": "Physician/Emergency Medicine",
	"94": "Physician/Interventional Radiology",
	"95": "Advance Diagnostic Imaging",
	"96": "Optician",
	"97": "Physician Assistant",
	"98": "Physician/Gynecological Oncology",
	"99": "Physician/Undefined Physician type",
	A0: "Hospital-Short-Term (General and Specialty)",
	A1: "Skilled Nursing Facility",
	A2: "Intermediate Care Nursing Facility",
	A3: "Other Nursing Facility",
	A4: "Home Health Agency (Subunit)",
	A5: "Pharmacy",
	A6: "Medical Supply Company with Respiratory Therapist",
	A7: "Department Store",
	A8: "Grocery Store",
	A9: "Indian Health Service facility",
	A10: "Pharmacy",
	A11: "Pharmacy",
	A12: "Pharmacy",
	A13: "Pharmacy",
	A14: "Pharmacy",
	A15: "Pharmacy",
	A16: "Pharmacy",
	A17: "Pharmacy",
	B1: "Oxygen supplier",
	B2: "Pedorthic personnel",
	B3: "Medical supply company with pedorthic personnel",
	B4: "",
	B5: "Ocularist",
	C0: "Physician/Interventional Cardiology",
	C3: "Physician/Interventional Cardiology",
	C5: "Dentist",
	C6: "Physician/Hospitalist",
	C7: "Physician/Advanced Heart Failure and Transplant Cardiology",
	C8: "Physician/Medical Toxicology",
	C9: "Hematopoietic Cell Transplantation and Cellular Therapy",
	D1: "Medicare Diabetes Preventive Program",
	D3: "Medical Genetics and Genomics",
	D4: "Undersea and Hyperbaric Medicine",
	D5: "Opioid Treatment Program",
	D6: "Home Infusion Therapy Services",
	D7: "Micrographic Dermatologic Surgery",
	D8: "Adult Congenital Heart Disease",
	E1: "Marriage and Family Therapist",
	E2: "Licensed Professional Counselor"
};

//#endregion
//#region src/claimAdapter/sailfish.ts
let SailfishUrlIds = /* @__PURE__ */ function(SailfishUrlIds) {
	SailfishUrlIds["abProviderMacJurisdiction"] = "https://fhir.rialtic.io/metadata/sailfish/ab_provider_mac_jurisdiction";
	SailfishUrlIds["admittingDiagnosis"] = "https://fhir.rialtic.io/metadata/sailfish/admitting_diagnosis";
	SailfishUrlIds["billingProviderId"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_id";
	SailfishUrlIds["billingProviderSpecialty1"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_1";
	SailfishUrlIds["billingProviderSpecialty1Raw"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_1_raw";
	SailfishUrlIds["billingProviderSpecialty2"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_2";
	SailfishUrlIds["billingProviderSpecialty2Raw"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_2_raw";
	SailfishUrlIds["billingProviderSpecialty3"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_3";
	SailfishUrlIds["billingProviderSpecialty3Raw"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_3_raw";
	SailfishUrlIds["billingProviderSpecialty4"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_4";
	SailfishUrlIds["billingProviderSpecialty4Raw"] = "https://fhir.rialtic.io/metadata/sailfish/billing_provider_specialty_4_raw";
	SailfishUrlIds["bypassCode"] = "https://fhir.rialtic.io/metadata/sailfish/bypass_code";
	SailfishUrlIds["casCntlClient"] = "https://fhir.rialtic.io/metadata/sailfish/cas_cntl_client";
	SailfishUrlIds["casEnvironment"] = "https://fhir.rialtic.io/metadata/sailfish/cas_environment";
	SailfishUrlIds["casSelectedProviderNpi"] = "https://fhir.rialtic.io/metadata/sailfish/cas_selected_provider_npi";
	SailfishUrlIds["cisId"] = "https://fhir.rialtic.io/metadata/sailfish/cis_id";
	SailfishUrlIds["cisReimbursementMethod"] = "https://fhir.rialtic.io/metadata/sailfish/cis_reimbursement_method";
	SailfishUrlIds["claimSubmitterIdentifier"] = "https://fhir.rialtic.io/metadata/sailfish/claim_submitter_identifier";
	SailfishUrlIds["conditionCodePartial"] = "https://fhir.rialtic.io/metadata/sailfish/condition_code";
	SailfishUrlIds["contractId"] = "https://fhir.rialtic.io/metadata/sailfish/contract_id";
	SailfishUrlIds["dmeMacJurisdiction"] = "https://fhir.rialtic.io/metadata/sailfish/dme_mac_jurisdiction";
	SailfishUrlIds["inputFormat"] = "https://fhir.rialtic.io/metadata/sailfish/inputFormat";
	SailfishUrlIds["insuranceId"] = "https://fhir.rialtic.io/metadata/sailfish/insurance_id";
	SailfishUrlIds["linePaidAmount"] = "https://fhir.rialtic.io/claimResponse/line/paidAmount/";
	SailfishUrlIds["ltssPlanIndicator"] = "https://fhir.rialtic.io/metadata/sailfish/ltss_plan_indicator";
	SailfishUrlIds["medicaidProviderType"] = "https://fhir.rialtic.io/metadata/sailfish/mcd_provider_type";
	SailfishUrlIds["medicaidProviderTypeRaw"] = "https://fhir.rialtic.io/metadata/sailfish/mcd_provider_type_raw";
	SailfishUrlIds["network"] = "https://fhir.rialtic.io/metadata/sailfish/network";
	SailfishUrlIds["networkId"] = "https://fhir.rialtic.io/metadata/sailfish/network_id";
	SailfishUrlIds["nonCoveredCharges"] = "https://fhir.rialtic.io/metadata/sailfish/non_covered_charges";
	SailfishUrlIds["occurrenceCodePartial"] = "https://fhir.rialtic.io/metadata/sailfish/occur_code";
	SailfishUrlIds["occurrenceCodeDatePartial"] = "https://fhir.rialtic.io/metadata/sailfish/occur_code_date";
	SailfishUrlIds["patientDischargeStatus"] = "https://fhir.rialtic.io/metadata/sailfish/patient_discharge_status";
	SailfishUrlIds["parIndicator"] = "https://fhir.rialtic.io/metadata/sailfish/par_indicator";
	SailfishUrlIds["patientId"] = "https://fhir.rialtic.io/metadata/sailfish/patient_id";
	SailfishUrlIds["payerBillingProviderId"] = "https://fhir.rialtic.io/metadata/sailfish/payer_billing_provider_id";
	SailfishUrlIds["payerBillingProviderProvType"] = "https://fhir.rialtic.io/metadata/sailfish/payer_billing_provider_prov_type";
	SailfishUrlIds["payerBillingProviderSubspec1"] = "https://fhir.rialtic.io/metadata/sailfish/payer_billing_provider_subspec_1";
	SailfishUrlIds["payorShort"] = "https://fhir.rialtic.io/metadata/sailfish/payor_short";
	SailfishUrlIds["platform"] = "https://fhir.rialtic.io/metadata/sailfish/platform";
	SailfishUrlIds["pricingMethodology"] = "https://fhir.rialtic.io/metadata/sailfish/pricing_methodology";
	SailfishUrlIds["principalProcedureCode"] = "https://fhir.rialtic.io/metadata/sailfish/procedure_1";
	SailfishUrlIds["principalProcedureDate"] = "https://fhir.rialtic.io/metadata/sailfish/procedure_date_1";
	SailfishUrlIds["revenueCode"] = "https://fhir.rialtic.io/metadata/sailfish/revenue_code";
	SailfishUrlIds["rialticMode"] = "https://fhir.rialtic.io/metadata/sailfish/_rialtic_mode";
	SailfishUrlIds["subscriberClass"] = "https://fhir.rialtic.io/metadata/sailfish/subscriber_class";
	SailfishUrlIds["valueCodePartial"] = "https://fhir.rialtic.io/metadata/sailfish/value_code";
	SailfishUrlIds["valueCodeAmountPartial"] = "https://fhir.rialtic.io/metadata/sailfish/value_code_amount";
	return SailfishUrlIds;
}({});

//#endregion
//#region src/claimAdapter/schema.ts
const ArrayWithLengthSchema = v.pipe(v.array(v.any()), v.nonEmpty());
const ValueMoneySchema = v.object({
	value: v.number(),
	currency: v.union([v.literal("USD"), v.string()])
});
const RialticSpecialtyCodeSchema = v.pipe(v.string(), v.nonEmpty(), v.custom((input) => {
	return Boolean(medicareProvSupplierDesc[input]);
}));
const SpecialtyCodeSchema = v.object({
	description: v.fallback(v.string(), ""),
	value: RialticSpecialtyCodeSchema,
	raw: v.fallback(v.string(), ""),
	error: v.optional(v.string())
});
const OccurrenceCodeItemSchema = v.object({
	code: v.string(),
	date: v.string()
});
const OccurrenceCodesSchema = v.array(OccurrenceCodeItemSchema);
const ValueCodeItemSchema = v.object({
	code: v.string(),
	amount: v.string()
});
const ValueCodesSchema = v.array(ValueCodeItemSchema);
const AdditionalIdsSchema = v.nullable(v.record(v.string(), v.nullable(v.string())));
const AdditionDetailsForClaimSchema = v.nullable(v.object({
	additionalIds: AdditionalIdsSchema,
	admittingDiagnosis: v.nullable(v.string()),
	cisReimbursementMethod: v.nullable(v.string()),
	conditionCodes: v.array(v.string()),
	ltssIndicator: v.nullable(v.string()),
	occurrenceCodes: OccurrenceCodesSchema,
	medicaidProviderType: v.nullable(v.string()),
	medicaidProviderTypeRaw: v.nullable(v.string()),
	parIndicator: v.nullable(v.string()),
	pricingMethodology: v.nullable(v.string()),
	specialtyCodes: v.nullable(v.record(v.string(), v.nullable(SpecialtyCodeSchema))),
	jurisdictionAb: v.nullable(v.string()),
	jurisdictionDme: v.nullable(v.string()),
	patientDischargeStatus: v.nullable(v.string()),
	payorShort: v.nullable(v.string()),
	principalProcedure: v.nullable(OccurrenceCodeItemSchema),
	valueCodes: ValueCodesSchema
}));
const AdditionDetailsForClaimLineSchema = v.nullable(v.object({
	additionalIds: AdditionalIdsSchema,
	bypassCode: v.nullable(v.string()),
	linePaidAmount: v.nullable(ValueMoneySchema),
	nonCoveredCharges: v.nullable(v.string()),
	parIndicator: v.nullable(v.string()),
	revenueCode: v.nullable(v.string())
}));

//#endregion
//#region src/claimAdapter/index.ts
const InstitutionalClaimTypes = [
	"asc_institutional",
	"inpatient",
	"outpatient"
];
const ProfessionalClaimTypes = ["asc_professional", "professional"];
const EMPTY_DIAGNOSIS_CODE = {
	codeableConcept: "",
	error: "not_found",
	sequence: Number.POSITIVE_INFINITY,
	type: ""
};
const getModifierCodes = (line) => line.modifier?.flatMap((m) => m.coding.map(({ code }) => code));
const getNdcCode = (claimLine) => {
	let ndc_code = null;
	if (claimLine.detail?.length) for (const item of claimLine.detail) {
		const ndc = item.productOrService?.coding.find((item) => item.system.includes("ndc_code"));
		if (ndc) {
			ndc_code = ndc.code;
			break;
		}
	}
	return ndc_code;
};
const getProviderTaxonomyCodes = (renderingProvider) => renderingProvider?.provider?.specialty?.map((s) => {
	return s.coding.reduce((accumulator, { code, system }) => {
		if (system.includes("PXC")) accumulator.push(code);
		return accumulator;
	}, []).join(" , ");
}).join(" , ");
const deserializeContained = (reference, containedMap) => {
	const id = reference.replace(/^#/, "");
	const item = containedMap.get(id);
	if (!item) return {};
	switch (item.resourceType) {
		case "Practitioner": {
			const identifiers = item?.identifier?.reduce((state, identifier) => {
				if (!identifier.system || typeof identifier.system !== "string") return state;
				if (identifier.system.endsWith("/providerIdentifier/EI")) state.ein = identifier.value;
				else if (identifier.system.endsWith("/providerIdentifier/NPI/XX")) state.npi = identifier.value;
				return state;
			}, {
				ein: null,
				npi: null
			});
			return defu({
				name: item?.name?.[0] || null,
				identifiers: {
					ein: null,
					npi: null,
					...identifiers
				},
				renderingProviderId: identifiers?.npi || null
			}, item);
		}
		case "PractitionerRole": return defu({ practitioner: deserializeContained(item.practitioner.reference, containedMap) }, item);
		default: return item;
	}
};
const getDiagnosisCode = (item) => {
	if (!item) return EMPTY_DIAGNOSIS_CODE;
	const rialticCode = item.diagnosisCodeableConcept.coding.find(({ system }) => system && typeof system === "string" && system.endsWith("/CodeSystem/diagnosiscode"));
	const [type] = item.type;
	const diagnosisType = type?.coding.find(({ system }) => system === "http://terminology.hl7.org/CodeSystem/ex-diagnosistype") || null;
	return {
		codeableConcept: !rialticCode?.code ? "" : rialticCode.code.length > 3 && !/\./g.test(rialticCode.code) ? `${rialticCode.code.slice(0, 3)}.${rialticCode.code.slice(3)}` : rialticCode.code,
		sequence: item.sequence,
		type: diagnosisType?.display || ""
	};
};
const getSpecialtyCode = (raw, value = "") => {
	const res = v.safeParse(SpecialtyCodeSchema, {
		description: medicareProvSupplierDesc[value],
		raw,
		value
	});
	if (res.success) return res.output;
	return {
		description: "",
		raw,
		value,
		error: res.issues[0].message
	};
};
const getTypeOfBillCode = (subType) => subType?.coding.find(({ system }) => system === "https://fhir.rialtic.io/fields/ub04/typeOfBill")?.code || null;
const isOccurrenceCodeValueUrl = (url) => url.includes(SailfishUrlIds.occurrenceCodePartial) && !url.includes(SailfishUrlIds.occurrenceCodeDatePartial);
const getOccurrenceCode = (item, extensions) => {
	const index = item.url.slice(-1);
	const date = extensions.find(({ url }) => url === `${SailfishUrlIds.occurrenceCodeDatePartial}_${index}`)?.valueString || "";
	return {
		code: item.valueString,
		date
	};
};
const isValueCodeValueUrl = (url) => url.includes(SailfishUrlIds.valueCodePartial) && !url.includes(SailfishUrlIds.valueCodeAmountPartial);
const getValueCode = (item, extensions) => {
	const index = item.url.slice(-1);
	const amount = extensions.find(({ url }) => url === `${SailfishUrlIds.valueCodeAmountPartial}_${index}`)?.valueString || "";
	return {
		code: item.valueString,
		amount
	};
};
const getPrincipalProcedure = (item, extensions) => {
	const date = extensions.find(({ url }) => url === SailfishUrlIds.principalProcedureDate)?.valueString || "";
	return {
		code: item.valueString || "",
		date
	};
};
const buildAdditionalDetails = (extensions) => {
	if (!v.is(ArrayWithLengthSchema, extensions)) return null;
	let admittingDiagnosis = null;
	let bypassCode = null;
	let cisReimbursementMethod = null;
	let pricingMethodology = null;
	let linePaidAmount = null;
	let ltssIndicator = null;
	let jurisdictionAb = null;
	let jurisdictionDme = null;
	let medicaidProviderType = null;
	let medicaidProviderTypeRaw = null;
	let nonCoveredCharges = null;
	let parIndicator = null;
	let payorShort = null;
	let patientDischargeStatus = null;
	let principalProcedure = null;
	let revenueCode = null;
	const specialtyCodes = {};
	const additionalIds = {};
	const conditionCodes = [];
	const occurrenceCodes = [];
	const valueCodes = [];
	for (const extension of extensions) {
		if (extension.url.includes(SailfishUrlIds.conditionCodePartial)) {
			conditionCodes.push(extension.valueString);
			continue;
		}
		if (isOccurrenceCodeValueUrl(extension.url)) {
			occurrenceCodes.push(getOccurrenceCode(extension, extensions));
			continue;
		}
		if (isValueCodeValueUrl(extension.url)) {
			valueCodes.push(getValueCode(extension, extensions));
			continue;
		}
		switch (extension.url) {
			case SailfishUrlIds.billingProviderSpecialty1Raw:
				specialtyCodes["1"] = getSpecialtyCode(extension.valueString, extensions.find(({ url }) => url === SailfishUrlIds.billingProviderSpecialty1)?.valueString);
				break;
			case SailfishUrlIds.billingProviderSpecialty2Raw:
				specialtyCodes["2"] = getSpecialtyCode(extension.valueString, extensions.find(({ url }) => url === SailfishUrlIds.billingProviderSpecialty2)?.valueString);
				break;
			case SailfishUrlIds.billingProviderSpecialty3Raw:
				specialtyCodes["3"] = getSpecialtyCode(extension.valueString, extensions.find(({ url }) => url === SailfishUrlIds.billingProviderSpecialty3)?.valueString);
				break;
			case SailfishUrlIds.billingProviderSpecialty4Raw:
				specialtyCodes["4"] = getSpecialtyCode(extension.valueString, extensions.find(({ url }) => url === SailfishUrlIds.billingProviderSpecialty4)?.valueString);
				break;
			case SailfishUrlIds.bypassCode:
				bypassCode = extension.valueString;
				break;
			case SailfishUrlIds.parIndicator:
				parIndicator = extension.valueString;
				break;
			case SailfishUrlIds.contractId:
				additionalIds.contract = extension.valueString;
				break;
			case SailfishUrlIds.networkId:
				additionalIds.network = extension.valueString;
				break;
			case SailfishUrlIds.payerBillingProviderId:
				additionalIds.altId = extension.valueString;
				break;
			case SailfishUrlIds.ltssPlanIndicator:
				ltssIndicator = extension.valueString;
				break;
			case SailfishUrlIds.abProviderMacJurisdiction:
				jurisdictionAb = extension.valueString;
				break;
			case SailfishUrlIds.dmeMacJurisdiction:
				jurisdictionDme = extension.valueString;
				break;
			case SailfishUrlIds.linePaidAmount:
				linePaidAmount = extension.valueMoney;
				break;
			case SailfishUrlIds.nonCoveredCharges:
				nonCoveredCharges = extension.valueString;
				break;
			case SailfishUrlIds.revenueCode:
				revenueCode = extension.valueString;
				break;
			case SailfishUrlIds.patientDischargeStatus:
				patientDischargeStatus = extension.valueString;
				break;
			case SailfishUrlIds.admittingDiagnosis:
				admittingDiagnosis = extension.valueString;
				break;
			case SailfishUrlIds.cisReimbursementMethod:
				cisReimbursementMethod = extension.valueString;
				break;
			case SailfishUrlIds.pricingMethodology:
				pricingMethodology = extension.valueString;
				break;
			case SailfishUrlIds.medicaidProviderType:
				medicaidProviderType = extension.valueString;
				break;
			case SailfishUrlIds.medicaidProviderTypeRaw:
				medicaidProviderTypeRaw = extension.valueString;
				break;
			case SailfishUrlIds.principalProcedureCode:
				principalProcedure = getPrincipalProcedure(extension, extensions);
				break;
			case SailfishUrlIds.payorShort:
				payorShort = extension.valueString ?? null;
				break;
			default: break;
		}
	}
	const hasAdditionalIds = !!Object.keys(additionalIds).length;
	const hasSpecialtyCodes = !!Object.keys(specialtyCodes).length;
	return {
		additionalIds: hasAdditionalIds ? additionalIds : null,
		admittingDiagnosis,
		cisReimbursementMethod,
		pricingMethodology,
		conditionCodes,
		bypassCode: bypassCode || null,
		linePaidAmount,
		ltssIndicator: ltssIndicator || null,
		jurisdictionAb,
		jurisdictionDme,
		medicaidProviderType,
		medicaidProviderTypeRaw,
		nonCoveredCharges,
		occurrenceCodes,
		parIndicator: parIndicator || null,
		patientDischargeStatus,
		payorShort,
		principalProcedure,
		revenueCode,
		specialtyCodes: hasSpecialtyCodes ? specialtyCodes : null,
		valueCodes
	};
};
const claimAdapter = ({ contained, item: claimLineItems, ...claim }) => {
	const containedMap = new Map(contained.map((item) => [item.id, item]));
	const warnings = [];
	const careTeam = claim.careTeam?.map((item) => {
		return defu({ provider: deserializeContained(item.provider.reference, containedMap) }, item);
	}) ?? [];
	const servicedPeriod = {
		start: "",
		end: ""
	};
	if (!claimLineItems.length) warnings.push({
		message: "Claim has no claim lines",
		data: { claim },
		type: "claim_lines_missing"
	});
	const insurance = claim.insurance.map((item) => {
		return {
			...item,
			coverage: deserializeContained(item.coverage.reference, containedMap),
			claimResponse: !item.claimResponse ? null : deserializeContained(item.claimResponse.reference || "", containedMap)
		};
	});
	const claimLines = claimLineItems.map((item, index) => {
		const careTeamSequence = item.careTeamSequence.map((num) => careTeam.find(({ sequence }) => sequence === num));
		const diagnosisSequence = item.diagnosisSequence.map((num) => claim.diagnosis.find(({ sequence }) => sequence === num));
		if (item.servicedPeriod) {
			const start = item.servicedPeriod.start;
			const end = item.servicedPeriod.end;
			if (!servicedPeriod.start) servicedPeriod.start = start;
			else servicedPeriod.start = isBefore(new Date(servicedPeriod.start), new Date(start)) ? start : servicedPeriod.start;
			if (!servicedPeriod.end) servicedPeriod.end = end;
			else servicedPeriod.end = isAfter(new Date(servicedPeriod.end), new Date(end)) ? end : servicedPeriod.end;
		}
		const diagnosisSequenceCodes = diagnosisSequence.map(getDiagnosisCode);
		const renderingProvider = careTeamSequence.find((careTeam) => careTeam?.role.coding.find((codeDetails) => codeDetails.code === "82"));
		if (diagnosisSequenceCodes.some((item) => item.error)) warnings.push({
			message: `Claim line ${item.sequence}: mismatch of diagnosis sequences`,
			data: {
				claimLine: item.sequence,
				diagnosisSequence: item.diagnosisSequence,
				diagnosis: claim.diagnosis
			},
			type: "diagnosis_sequence_mismatch"
		});
		const [diagnosis1, ...diagnosisAdditional] = diagnosisSequenceCodes;
		if (!renderingProvider?.provider?.specialty) warnings.push({
			message: `Claim line ${item.sequence}: no provider specialty`,
			data: {
				claimLine: item.sequence,
				careTeamSequence,
				renderingProvider
			},
			type: "provider_specialty_missing"
		});
		const addItemExtension = insurance[0]?.claimResponse?.addItem?.find(({ itemSequence }) => itemSequence?.[0] === item.sequence)?.extension || [];
		return {
			...item,
			additionalDetails: buildAdditionalDetails((item.extension || []).concat(addItemExtension)),
			billingName: renderingProvider?.provider?.practitioner?.name?.family?.toLowerCase(),
			careTeamSequence,
			diagnosis1: diagnosis1 || EMPTY_DIAGNOSIS_CODE,
			diagnosisAdditional,
			diagnosisSequence,
			excludedCount: 0,
			hasInsights: false,
			hasInsightScore: false,
			insights: [],
			lineNumber: index + 1,
			modifierCodes: getModifierCodes(item),
			ndcCode: getNdcCode(item),
			providerTaxonomyCodes: getProviderTaxonomyCodes(renderingProvider),
			renderingProvider: {
				...renderingProvider,
				identifiers: { ...renderingProvider?.provider?.practitioner?.identifiers }
			},
			renderingProviderIdentifiers: renderingProvider?.provider?.practitioner?.identifiers || null
		};
	});
	const diagnosisCodes = [...claim.diagnosis].map(getDiagnosisCode);
	const principalDiagnosisCode = diagnosisCodes.find(({ type }) => /principal/i.test(type))?.codeableConcept || null;
	const provider = deserializeContained(claim.provider.reference, containedMap);
	const billingProviderIdentifiers = provider.practitioner?.identifiers || null;
	const memberGroupId = insurance?.[0]?.coverage.class?.find(({ type }) => type.text === "policy/group number")?.value ?? null;
	const patient = deserializeContained(claim.patient.reference, containedMap);
	const patientNameObject = patient?.name?.[0];
	const patientName = !patientNameObject ? null : patientNameObject.given?.length ? `${patientNameObject.family}, ${patientNameObject.given[0]}` : patientNameObject.family;
	const subscriberId = insurance?.[0]?.coverage.subscriberId ?? null;
	const claimType = claim.type?.coding?.[0]?.code ?? "";
	const formType = InstitutionalClaimTypes.includes(claimType) ? "institutional" : "professional";
	const claimResponseExtension = containedMap.get(`ClaimResponse-${claim.id}`)?.extension || [];
	return {
		...claim,
		additionalDetails: buildAdditionalDetails([...claim.extension, ...claimResponseExtension]),
		billingProviderIdentifiers,
		diagnosisCodes,
		careTeam,
		claimLines: claimLines ?? [],
		formType,
		insurance,
		memberGroupId,
		patient,
		patientName,
		provider,
		principalDiagnosisCode,
		servicedPeriod,
		subscriberId,
		type: claimType,
		typeOfBill: getTypeOfBillCode(claim.subType),
		warnings
	};
};

//#endregion
//#region ../types/src/enums.ts
let AppConfigKeys = /* @__PURE__ */ function(AppConfigKeys) {
	AppConfigKeys["maintenance"] = "maintenance";
	AppConfigKeys["featureClaimTypeAnalyticsRows"] = "feature_claim_type_analytics_rows";
	AppConfigKeys["featurePolicyOverrides"] = "feature_policy_overrides";
	return AppConfigKeys;
}({});
let ClaimType = /* @__PURE__ */ function(ClaimType) {
	ClaimType["Professional"] = "Professional";
	ClaimType["ASCProfessional"] = "ASC billed on professional form";
	ClaimType["ASCInstitutional"] = "ASC billed on institutional form";
	ClaimType["Outpatient"] = "Institutional outpatient";
	ClaimType["Inpatient"] = "Institutional inpatient";
	ClaimType["NoClaimTypes"] = "No claim types";
	ClaimType["AllClaimTypes"] = "Any claim type";
	return ClaimType;
}({});
let ClaimTypeShort = /* @__PURE__ */ function(ClaimTypeShort) {
	ClaimTypeShort["Professional"] = "Professional";
	ClaimTypeShort["ASCProfessional"] = "ASC on professional";
	ClaimTypeShort["ASCInstitutional"] = "ASC on institutional";
	ClaimTypeShort["Outpatient"] = "Outpatient";
	ClaimTypeShort["Inpatient"] = "Inpatient";
	return ClaimTypeShort;
}({});
let ClaimTypeHiro = /* @__PURE__ */ function(ClaimTypeHiro) {
	ClaimTypeHiro["Professional"] = "professional";
	ClaimTypeHiro["ASCProfessional"] = "asc_professional";
	ClaimTypeHiro["ASCInstitutional"] = "asc_institutional";
	ClaimTypeHiro["Outpatient"] = "outpatient";
	ClaimTypeHiro["Inpatient"] = "inpatient";
	return ClaimTypeHiro;
}({});
const ClaimTypeValues = Object.values(ClaimType);
let HistoryType = /* @__PURE__ */ function(HistoryType) {
	HistoryType["Off"] = "Off";
	HistoryType["Days"] = "Lookback days";
	HistoryType["Infinite"] = "Infinite";
	return HistoryType;
}({});
const HistoryTypeValues = Object.values(HistoryType);

//#endregion
//#region ../types/src/validation.ts
const DateStringSchema = v.pipe(v.string("Must be string"), v.isoDate("Must be a date formatted as yyyy-MM-dd"));
const BooleanEnumSchema = v.picklist(["true", "false"]);
const QueryBooleanSchema = v.pipe(v.optional(BooleanEnumSchema), v.transform((value) => value === "true"));
const QueryNumberSchema = v.pipe(v.string(), v.regex(/^\d+$/), v.transform((value) => +value));
const QueryStringArraySchema = v.pipe(v.union([v.array(v.string()), v.string()]), v.transform((value) => Array.isArray(value) ? value : [value]));

//#endregion
//#region ../types/src/index.ts
const WORKSPACE_ID_HEADER = "x-rialtic-workspace-id";
const forwardedHeaders = {
	accept: true,
	authorization: true,
	[WORKSPACE_ID_HEADER]: true,
	"cache-control": true,
	"content-type": true,
	cookie: true,
	"if-none-match": true,
	"if-modified-since": true,
	origin: true,
	traceparent: true
};
const featureFlags = {
	[AppConfigKeys.featurePolicyOverrides]: false,
	[AppConfigKeys.maintenance]: false
};

//#endregion
//#region src/claimTypes.ts
const claimTypeFlagsShape = {
	is_claim_type_professional: true,
	is_claim_type_inpatient: true,
	is_claim_type_outpatient: true,
	is_claim_type_asc_professional: true,
	is_claim_type_asc_institutional: true,
	is_all_claim_types: true
};
const CLAIM_TYPE_FLAG_KEYS = Object.keys(claimTypeFlagsShape);
const claimTypeFlagToHiro = {
	is_claim_type_professional: ClaimTypeHiro.Professional,
	is_claim_type_inpatient: ClaimTypeHiro.Inpatient,
	is_claim_type_outpatient: ClaimTypeHiro.Outpatient,
	is_claim_type_asc_professional: ClaimTypeHiro.ASCProfessional,
	is_claim_type_asc_institutional: ClaimTypeHiro.ASCInstitutional
};
const claimTypeMap = {
	[ClaimTypeHiro.Professional]: ClaimType.Professional,
	[ClaimTypeHiro.ASCProfessional]: ClaimType.ASCProfessional,
	[ClaimTypeHiro.ASCInstitutional]: ClaimType.ASCInstitutional,
	[ClaimTypeHiro.Outpatient]: ClaimType.Outpatient,
	[ClaimTypeHiro.Inpatient]: ClaimType.Inpatient
};
const claimTypeMapShort = {
	[ClaimTypeHiro.Professional]: ClaimTypeShort.Professional,
	[ClaimTypeHiro.ASCProfessional]: ClaimTypeShort.ASCProfessional,
	[ClaimTypeHiro.ASCInstitutional]: ClaimTypeShort.ASCInstitutional,
	[ClaimTypeHiro.Outpatient]: ClaimTypeShort.Outpatient,
	[ClaimTypeHiro.Inpatient]: ClaimTypeShort.Inpatient
};
const institutionalFlags = [
	ClaimTypeHiro.ASCInstitutional,
	ClaimTypeHiro.Outpatient,
	ClaimTypeHiro.Inpatient
];
const typeDescriptions = {
	[ClaimTypeHiro.Professional]: "Claim submitted for practitioner professional service using the 837p / CMS 1500 form (or equivalent)",
	[ClaimTypeHiro.ASCProfessional]: "Claim submitted for the institutional portion of an ASC encounter using the 837p / CMS 1500 form (or equivalent)",
	[ClaimTypeHiro.ASCInstitutional]: "Claim submitted for the institutional portion of an ASC encounter using the 837i / UB-04 form (or equivalent)",
	[ClaimTypeHiro.Outpatient]: "Claim submitted for the institutional portion of an outpatient encounter using the 837i / UB-04 form (or equivalent)",
	[ClaimTypeHiro.Inpatient]: "Claim submitted for the institutional portion of an inpatient encounter using the 837i / UB-04 form (or equivalent)"
};
const claimTypeLabels = (flags) => {
	if (!flags) return [];
	const list = [];
	if (flags.is_all_claim_types) {
		list.push(ClaimType.AllClaimTypes);
		return list;
	}
	if (flags.is_claim_type_professional) list.push(ClaimType.Professional);
	if (flags.is_claim_type_inpatient) list.push(ClaimType.Inpatient);
	if (flags.is_claim_type_outpatient) list.push(ClaimType.Outpatient);
	if (flags.is_claim_type_asc_professional) list.push(ClaimType.ASCProfessional);
	if (flags.is_claim_type_asc_institutional) list.push(ClaimType.ASCInstitutional);
	return list;
};

//#endregion
//#region src/epicTapestryMapping.ts
/**
* Optionally, the customer can associate an action code with the response directive.
* This way, the customer can assign different claim codes for the same response directive, depending on the associated action.
* For example, if response directive 300 represents an informational recommendation, the customer could map response directive 300 to two actions, Add Modifier and Remove Modifier, each with its own claim code.
* @see https://www.notion.so/rialtic/ERS-Integration-With-Tapestry-EPIC-API-1faf1bc6f9e380c88d62e7dbb665ad83
*
* 0-No Change to Service Line
* 1-Add New Service Line
* 2-Add Modifier(s) to Service Line
* 3-Remove Modifier(s) from Service Line
* 4-Change Service Code on Service Line
* 5-Change Quantity on Service Line
* 6-Change Amount on Service Line
* 7-Change Associated Diagnoses on Service Line
* 8-Change Place of Service Type on Service Line
* 9-Change Type of Service on Service Line
* 10-Change Drug Information on Service Line
*/
const ACTION_CODE = {
	no_change_to_service_line: 0,
	add_new_service_line: 1,
	add_modifier_to_service_line: 2,
	remove_modifier_from_service_line: 3,
	change_service_code_on_service_line: 4,
	change_quantity_on_service_line: 5,
	change_amount_on_service_line: 6,
	change_associated_diagnoses_on_service_line: 7,
	change_place_of_service_type_on_service_line: 8,
	change_type_of_service_on_service_line: 9,
	change_drug_information_on_service_line: 10
};
const BASE_RESPONSE = {
	deny: 1e8,
	info: 3e8,
	pend: 2e8,
	allow: 4e8
};
const INTERNAL_CODE = {
	deny: "D",
	modify: "M",
	allow: "A"
};
const ACTIONABLE_INSIGHT_TYPE = {
	claim_not_payable: "Claim Not Payable",
	claim_line_not_payable: "Claim Line Not Payable",
	claim_line_partially_payable: "Claim Line Partially Payable",
	recode_claim_line: "Recode Claim Line",
	manual_review: "Manual Review"
};
const EPIC_EXPORT_MAPPING = {
	[ACTIONABLE_INSIGHT_TYPE.claim_not_payable]: {
		insightType: ACTIONABLE_INSIGHT_TYPE.claim_not_payable,
		responseDirectiveBaseResponse: BASE_RESPONSE.deny,
		actionCode: ACTION_CODE.no_change_to_service_line,
		internalCode: INTERNAL_CODE.deny
	},
	[ACTIONABLE_INSIGHT_TYPE.claim_line_not_payable]: {
		insightType: ACTIONABLE_INSIGHT_TYPE.claim_line_not_payable,
		responseDirectiveBaseResponse: BASE_RESPONSE.deny,
		actionCode: ACTION_CODE.no_change_to_service_line,
		internalCode: INTERNAL_CODE.deny
	},
	[ACTIONABLE_INSIGHT_TYPE.claim_line_partially_payable]: {
		insightType: ACTIONABLE_INSIGHT_TYPE.claim_line_partially_payable,
		responseDirectiveBaseResponse: BASE_RESPONSE.info,
		actionCode: ACTION_CODE.change_quantity_on_service_line,
		internalCode: INTERNAL_CODE.modify
	},
	[ACTIONABLE_INSIGHT_TYPE.recode_claim_line]: {
		insightType: ACTIONABLE_INSIGHT_TYPE.recode_claim_line,
		responseDirectiveBaseResponse: BASE_RESPONSE.info,
		actionCode: ACTION_CODE.add_modifier_to_service_line,
		internalCode: INTERNAL_CODE.modify
	},
	[ACTIONABLE_INSIGHT_TYPE.manual_review]: {
		insightType: ACTIONABLE_INSIGHT_TYPE.manual_review,
		responseDirectiveBaseResponse: BASE_RESPONSE.pend,
		actionCode: ACTION_CODE.no_change_to_service_line
	}
};
const POLICY_ID_PREFIX = "policy_";
const parseNumericPolicyId = (policyId) => {
	if (!policyId) return void 0;
	if (!policyId.startsWith(POLICY_ID_PREFIX)) return void 0;
	const suffix = policyId.slice(7);
	const parsed = Number.parseInt(suffix, 10);
	if (!Number.isFinite(parsed)) return void 0;
	return parsed;
};
const generatePolicyResponseDirectiveActionCode = (policyId, actionableInsightType) => {
	if (!actionableInsightType) return null;
	const numericPolicyId = parseNumericPolicyId(policyId);
	const epicFormattedPolicies = [];
	for (const insightType of actionableInsightType) {
		const mapping = EPIC_EXPORT_MAPPING[insightType];
		if (!mapping) continue;
		if (numericPolicyId === void 0) continue;
		epicFormattedPolicies.push({
			response_directive: mapping.responseDirectiveBaseResponse + numericPolicyId,
			action_code: mapping.actionCode
		});
	}
	return epicFormattedPolicies.length ? epicFormattedPolicies : null;
};

//#endregion
//#region src/formatBytes.ts
/**
* Formats bytes into human-readable string (KB, MB, GB, etc.)
* @param bytes - The number of bytes to format
* @param decimals - Number of decimal places to show (default: 2)
* @returns Formatted string with appropriate unit
*/
const formatBytes = (bytes, decimals = 2) => {
	if (bytes < 0) throw new RangeError("bytes must be non-negative");
	if (bytes === 0) return "0 Bytes";
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = [
		"Bytes",
		"KB",
		"MB",
		"GB",
		"TB",
		"PB",
		"EB",
		"ZB",
		"YB"
	];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

//#endregion
//#region src/insights.ts
const orderInsightsByScore = (insights) => {
	if (!insights) return [];
	return [...insights].sort((a, b) => {
		const aScore = a.is_recommendation ? (a.insight_score || 1e3) * 100 : a.insight_score || 1;
		const bScore = b.is_recommendation ? (b.insight_score || 1e3) * 100 : b.insight_score || 1;
		if (bScore !== aScore) return bScore - aScore;
		if (a.insight.insight_mode !== b.insight.insight_mode) return a.insight.insight_mode.localeCompare(b.insight.insight_mode);
		if (a.insight.policy_id && b.insight.policy_id) {
			if (a.insight.policy_id !== b.insight.policy_id) return a.insight.policy_id.localeCompare(b.insight.policy_id);
		} else if (a.insight.policy_id) return -1;
		else if (b.insight.policy_id) return 1;
		return a.insight.insight.id.localeCompare(b.insight.insight.id);
	});
};

//#endregion
//#region src/policies.ts
const getApplicableClaimTypes = (policy, claimTypeFlags) => {
	const claimTypes = {
		professional: {
			active: policy.is_claim_type_professional,
			label: "Professional"
		},
		asc_professional: {
			active: policy?.is_claim_type_asc_professional,
			label: "ASC billed on professional form"
		},
		asc_institutional: {
			active: policy?.is_claim_type_asc_institutional,
			label: "ASC billed on institutional form"
		},
		outpatient: {
			active: policy?.is_claim_type_outpatient,
			label: "Institutional outpatient"
		},
		inpatient: {
			active: policy?.is_claim_type_inpatient,
			label: "Institutional inpatient"
		}
	};
	return claimTypeFlags.reduce((acc, key) => {
		const mappedClaimType = claimTypes[key];
		if (mappedClaimType?.active) acc.push({
			label: mappedClaimType.label,
			key
		});
		return acc;
	}, []);
};
/**
* The excerpt a policy is attributed to on a reference document version.
*
* A version carries at most one attributed excerpt: either its own, or one carried forward
* from an earlier version under excerpt_reference_document_versions. `policy_excerpt` is
* the pre-excerpt-migration column, kept aligned by the backend and used for payloads that
* select the excerpt relations without their text.
*/
const getReferenceDocumentVersionExcerpt = (version) => {
	if (!version) return null;
	return version.excerpts?.[0]?.excerpt || version.excerpt_reference_document_versions?.[0]?.excerpt?.excerpt || version.policy_excerpt || null;
};

//#endregion
//#region src/queryHelpers.ts
const STALE_TIME = {
	FIVE_SECONDS: 1e3 * 5,
	THIRTY_SECONDS: 1e3 * 30,
	ONE_MINUTE: 1e3 * 60,
	FIVE_MINUTES: 1e3 * 60 * 5,
	FIFTEEN_MINUTES: 1e3 * 60 * 15,
	THIRTY_MINUTES: 1e3 * 60 * 30,
	ONE_HOUR: 1e3 * 60 * 60,
	ONE_DAY: 1e3 * 60 * 60 * 24,
	ONE_WEEK: 1e3 * 60 * 60 * 24 * 7
};

//#endregion
//#region src/stringHelpers.ts
/**
* Capitalizes the first character of a string and lowers the rest.
* @param str - The string to capitalize
* @returns Capitalized string
*/
const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

//#endregion
//#region src/workspace.ts
const getClaimTypeFeatureFlags = (workspace) => {
	if (!workspace.system_document) return [];
	const systemDocument = workspace.system_document;
	return [
		"professional",
		"asc_professional",
		"asc_institutional",
		"outpatient",
		"inpatient"
	].filter((flag) => systemDocument[flag]);
};
const isTobAndRevCodeEnabled = (workspace) => {
	if (!workspace) return false;
	return getClaimTypeFeatureFlags(workspace).some((flag) => institutionalFlags.includes(flag));
};

//#endregion
//#region src/json.ts
/**
* Safely parses a JSON string, returning a Result type instead of throwing.
* @param input - The JSON string to parse
* @returns Result containing the parsed value or an error
*/
const safeJsonParse = fromThrowable(JSON.parse);
/**
* Safely stringifies a value, returning a Result type instead of throwing.
* @param input - The value to stringify
* @returns Result containing the stringified value or an error
*/
const safeJsonStringify = fromThrowable(JSON.stringify);

//#endregion
//#region src/agents/websockets.ts
/**
* Parses a WebSocket message string as JSON.
* @param ms - The WebSocket message to parse (expected to be a JSON string)
* @returns A Result containing the parsed message object, or an error if parsing fails
*/
function parseWsMessageAsJson(ms) {
	let msString;
	if (typeof ms === "string") msString = ms;
	else if (ms instanceof ArrayBuffer || ArrayBuffer.isView(ms)) try {
		msString = new TextDecoder().decode(ms);
	} catch (error) {
		return err(/* @__PURE__ */ new Error(`Could not decode ArrayBuffer message: ${error instanceof Error ? error.message : error}`));
	}
	else return err(/* @__PURE__ */ new Error(`Invalid message type: ${typeof ms}`));
	const result = safeJsonParse(msString);
	if (result.isErr()) return err(/* @__PURE__ */ new Error(`Could not parse JSON: ${result.error instanceof Error ? result.error.message : result.error}`));
	return ok(result.value);
}

//#endregion
//#region src/isNonNullable.ts
/**
* A type predicate that checks if a value is not null and not undefined.
* Useful for filtering out null/undefined values from arrays in a type-safe way.
*
* @example
* const array = [1, null, 2, undefined, 3];
* const numbers = array.filter(isNonNullable); // Type is number[]
*/
const isNonNullable = (value) => {
	return value !== null && value !== void 0;
};

//#endregion
//#region src/ref-data/icd10.ts
var icd10_exports = /* @__PURE__ */ __exportAll({
	buildIcd10Hierarchy: () => buildIcd10Hierarchy,
	compareIcd10Codes: () => compareIcd10Codes,
	consolidateIcd10Codes: () => consolidateIcd10Codes,
	consolidateIcd10CodesWithMetadata: () => consolidateIcd10CodesWithMetadata,
	consolidateToRanges: () => consolidateToRanges,
	expandIcd10Codes: () => expandIcd10Codes,
	formatIcd10Code: () => formatIcd10Code,
	getAllDescendants: () => getAllDescendants,
	getChildCodes: () => getChildCodes,
	getParentCode: () => getParentCode,
	icd10InternalsForTesting: () => icd10InternalsForTesting,
	isIcd10CodeCoveredBy: () => isIcd10CodeCoveredBy,
	isIcd10RangeOrWildcard: () => isIcd10RangeOrWildcard,
	normalizeIcd10Codes: () => normalizeIcd10Codes,
	normalizeIcd10Key: () => normalizeIcd10Key,
	rollupToWildcards: () => rollupToWildcards,
	splitIcd10CodeList: () => splitIcd10CodeList
});
/**
* Formats a single ICD-10 code segment by ensuring proper decimal placement.
* ICD-10 codes have a decimal after the 3rd character if longer than 3.
*/
const formatSingle = (code) => {
	const trimmed = code.trim().toUpperCase();
	if (trimmed.includes(".")) return trimmed;
	if (trimmed.length > 3) return `${trimmed.slice(0, 3)}.${trimmed.slice(3)}`;
	return trimmed;
};
/**
* Formats an ICD-10 code string by ensuring proper decimal placement.
* Handles discrete codes, ranges, and wildcards.
*
* @example
* formatIcd10Code("G241") → "G24.1"
* formatIcd10Code("G24.1") → "G24.1"
* formatIcd10Code("G24") → "G24"
* formatIcd10Code("D6851-D6869") → "D68.51-D68.69"
* formatIcd10Code("D685*") → "D68.5*"
*/
const formatIcd10Code = (code) => {
	const trimmed = code.trim().toUpperCase();
	if (trimmed.endsWith("*")) return `${formatSingle(trimmed.slice(0, -1))}*`;
	if (trimmed.includes("-")) return trimmed.split("-").map((p) => formatSingle(p)).join("-");
	return formatSingle(trimmed);
};
/**
* Splits a string that may contain several ICD-10 codes or ranges into
* individual entries. LLM extraction occasionally crams a whole "covered
* codes" table cell into one value (e.g. `"C00.0-C43.9, C44.00-C75.9"`); this
* separates them so each is formatted, normalized, and rendered on its own.
*
* Splits on commas, semicolons, and newlines — never on hyphens (range
* delimiters) or asterisks (wildcards), so a legitimate single range like
* `"C00-C14"` stays intact.
*
* @example
* splitIcd10CodeList("C00.0-C43.9, C44.00-C75.9") → ["C00.0-C43.9", "C44.00-C75.9"]
* splitIcd10CodeList("J12.89; M05.9") → ["J12.89", "M05.9"]
* splitIcd10CodeList("C00-C14") → ["C00-C14"]
* splitIcd10CodeList("G70.00") → ["G70.00"]
*/
const splitIcd10CodeList = (code) => code.split(/[,;\n]+/).map((part) => part.trim()).filter((part) => part.length > 0);
/** Strips dots and spaces, then uppercases — used to compare ICD-10 codes regardless of formatting. */
const normalizeIcd10Key = (code) => code.replace(/[.\s]/g, "").toUpperCase();
/** Returns `true` when the code represents a range (`-`) or wildcard (`*`) pattern. */
const isIcd10RangeOrWildcard = (code) => code.includes("-") || code.endsWith("*");
/**
* Returns true when `code` is already represented by `coveringCode`.
* Handles exact matches, ranges, and wildcards using normalized ICD-10 keys, so
* dotted and undotted inputs compare the same.
*/
const isIcd10CodeCoveredBy = (code, coveringCode) => isAbsorbedByOutput(code, coveringCode);
/**
* Extracts a sortable key from an ICD-10 code string.
* Ranges sort by their start code, wildcards sort by their prefix.
*/
const icd10SortKey = (code) => {
	const trimmed = code.trim().toUpperCase();
	return normalizeIcd10Key(trimmed.endsWith("*") ? trimmed.slice(0, -1) : trimmed.includes("-") ? trimmed.split("-")[0]?.trim() ?? trimmed : trimmed);
};
/**
* Comparator for sorting ICD-10 code strings in alphanumeric ascending order.
* Ranges sort by start code, wildcards sort by prefix.
* Display-only — does not mutate the input array.
*/
const compareIcd10Codes = (a, b) => icd10SortKey(a).localeCompare(icd10SortKey(b)) || a.trim().toUpperCase().localeCompare(b.trim().toUpperCase());
/**
* Canonicalizes an ICD-10 input: trims, uppercases, adds decimals, normalizes
* range separator spacing, and preserves wildcard/range syntax.
*/
const canonicalizeIcd10Input = (code) => {
	const trimmed = code.trim().toUpperCase();
	if (!trimmed) return "";
	return formatIcd10Code(trimmed);
};
/**
* True when `item` (discrete, range, or wildcard) is fully absorbed by `output`.
* Ranges/wildcards are absorbed when both endpoints / wildcard base fall within
* the output's coverage. Same-canonical-form codes are never absorbed (they are
* deduplicated into the same bucket instead).
*/
const isItemAbsorbedBy = (item, output) => {
	if (normalizeIcd10Key(item) === normalizeIcd10Key(output) && item === output) return false;
	if (item.endsWith("*")) return isAbsorbedByOutput(item.replace(wildcardSuffixPattern, ""), output);
	if (item.includes(rangeSeparator)) {
		const range = parseRange(item);
		if (!range) return false;
		return isAbsorbedByOutput(range[0], output) && isAbsorbedByOutput(range[1], output);
	}
	return isAbsorbedByOutput(item, output);
};
/**
* Semantically normalizes ICD-10 entries by removing redundant overlap while
* preserving and merging metadata.
*
* Behavior:
* - Deduplicates identical codes (case/format-insensitive)
* - Removes discrete codes covered by active ranges or wildcards
* - Removes ranges covered by active broader ranges or wildcards
* - Removed (`isRemoved: true`) covers do not absorb other codes
* - Merges metadata from absorbed entries (`sourceReference`, `reasoning`,
*   and boolean flags where `true` wins)
* - Returns stable, display-formatted codes sorted alphabetically
*/
const normalizeIcd10Codes = (codes) => {
	if (!codes || codes.length === 0) return [];
	const items = codes.map((input) => ({
		input,
		canonical: canonicalizeIcd10Input(input.code)
	})).filter((it) => it.canonical !== "");
	const covers = items.filter((it) => it.canonical.endsWith("*") || it.canonical.includes(rangeSeparator));
	const pickHost = (itemCanonical) => {
		const candidates = covers.filter((c) => !c.input.isRemoved && c.canonical !== itemCanonical && isItemAbsorbedBy(itemCanonical, c.canonical));
		if (candidates.length === 0) return itemCanonical;
		const topLevel = candidates.filter((c) => !candidates.some((other) => other.canonical !== c.canonical && isItemAbsorbedBy(c.canonical, other.canonical)));
		return [...topLevel.length > 0 ? topLevel : candidates].map((c) => c.canonical).sort((a, b) => a.localeCompare(b))[0] ?? "";
	};
	const bucketsByCanonical = /* @__PURE__ */ new Map();
	for (const { input, canonical } of items) {
		const host = pickHost(canonical);
		const bucket = bucketsByCanonical.get(host) ?? [];
		bucket.push(input);
		bucketsByCanonical.set(host, bucket);
	}
	const result = [];
	for (const [canonical, absorbed] of bucketsByCanonical) {
		const meta = buildMetadataFromInputs(absorbed);
		result.push({
			code: canonical,
			isRange: canonical.includes(rangeSeparator) && !canonical.endsWith("*"),
			isSecondary: meta.isSecondary,
			isManuallyAdded: meta.isManuallyAdded,
			isSuggested: meta.isSuggested,
			isRemoved: meta.isRemoved,
			sourceReference: meta.sourceReference,
			reasoning: meta.reasoning
		});
	}
	return result.sort((a, b) => compareIcd10Codes(a.code, b.code));
};
const wildcardSuffixPattern = /\*$/;
const rangeSeparator = "-";
const ordinalAlphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const getSharedPrefixLength = (a, b) => {
	const limit = Math.min(a.length, b.length);
	let index = 0;
	while (index < limit && a[index] === b[index]) index += 1;
	return index;
};
const toCanonicalCode = (code) => formatIcd10Code(code.trim().toUpperCase());
const stripWildcardSuffix = (code) => code.replace(wildcardSuffixPattern, "");
const normalizeDiscreteCode = (code) => normalizeIcd10Key(formatIcd10Code(code.trim().toUpperCase()));
const parseRange = (rangeCode) => {
	const segments = rangeCode.split(rangeSeparator);
	if (segments.length !== 2) return null;
	const start = formatIcd10Code(segments[0]?.trim().toUpperCase() ?? "");
	const end = formatIcd10Code(segments[1]?.trim().toUpperCase() ?? "");
	if (!start || !end) return null;
	return [start, end];
};
const formatWildcardFromBase = (base) => `${formatIcd10Code(base.replace(wildcardSuffixPattern, ""))}*`;
const isConsecutiveSibling = (previousKey, currentKey, parentKey) => {
	const previousSuffix = previousKey.slice(parentKey.length);
	const currentSuffix = currentKey.slice(parentKey.length);
	if (!previousSuffix || !currentSuffix) return false;
	if (previousSuffix.length !== currentSuffix.length) return false;
	if (previousSuffix.slice(0, -1) !== currentSuffix.slice(0, -1)) return false;
	const previousOrdinal = ordinalAlphabet.indexOf(previousSuffix.at(-1) ?? "");
	const currentOrdinal = ordinalAlphabet.indexOf(currentSuffix.at(-1) ?? "");
	if (previousOrdinal === -1 || currentOrdinal === -1) return false;
	return currentOrdinal === previousOrdinal + 1;
};
/**
* Derives a direct parent code using pure string derivation.
* The function progressively removes one normalized character until no parent exists.
*
* @example
* getParentCode('G24.10') -> 'G24.1'
* getParentCode('G24.1') -> 'G24'
* getParentCode('G24') -> null
*/
const getParentCode = (code) => {
	const normalized = normalizeIcd10Key(stripWildcardSuffix(code));
	if (normalized.length <= 3) return null;
	return formatIcd10Code(normalized.slice(0, -1));
};
const getNormalizedParentKey = (code) => normalizeIcd10Key(getParentCode(code) ?? "");
/**
* Builds parent/child ICD-10 hierarchy maps from a flat reference list.
* Parents are resolved by progressive string shortening and nearest-known-parent matching.
*/
const buildIcd10Hierarchy = (codes) => {
	const codesByKey = {};
	for (const code of codes) {
		const canonical = toCanonicalCode(code);
		if (isIcd10RangeOrWildcard(canonical)) continue;
		const key = normalizeIcd10Key(canonical);
		if (!key) continue;
		if (!codesByKey[key]) codesByKey[key] = canonical;
	}
	const extendedByKey = { ...codesByKey };
	for (const code of Object.values(codesByKey)) {
		let parentCandidate = getParentCode(code);
		while (parentCandidate) {
			const parentKey = normalizeIcd10Key(parentCandidate);
			if (!extendedByKey[parentKey]) extendedByKey[parentKey] = parentCandidate;
			parentCandidate = getParentCode(parentCandidate);
		}
	}
	const childrenByParent = /* @__PURE__ */ new Map();
	const parentByChild = {};
	for (const [childKey, childCode] of Object.entries(codesByKey)) {
		let parentCandidate = getParentCode(childCode);
		while (parentCandidate) {
			const parentKey = normalizeIcd10Key(parentCandidate);
			const parentCode = codesByKey[parentKey];
			if (parentCode) {
				if (!childrenByParent.has(parentKey)) childrenByParent.set(parentKey, /* @__PURE__ */ new Set());
				childrenByParent.get(parentKey).add(childCode);
				parentByChild[childKey] = parentCode;
				break;
			}
			parentCandidate = getParentCode(parentCandidate);
		}
	}
	return {
		childrenByParent: Object.fromEntries([...childrenByParent.entries()].map(([parentKey, children]) => [parentKey, [...children].sort(compareIcd10Codes)])),
		parentByChild,
		codesByKey
	};
};
/**
* Returns direct child codes for the provided parent code.
*/
const getChildCodes = (parent, hierarchy) => {
	const parentKey = normalizeIcd10Key(stripWildcardSuffix(parent));
	return hierarchy.childrenByParent[parentKey] ?? [];
};
/**
* Returns all descendant codes whose normalized key starts with the provided prefix.
* Includes the exact prefix code itself when present in reference data, including
* when a trailing wildcard was present (e.g. "G24.1*" includes "G24.1" plus all descendants).
*/
const getAllDescendants = (prefix, hierarchy) => {
	const prefixKey = normalizeIcd10Key(stripWildcardSuffix(prefix));
	if (!prefixKey) return [];
	return Object.values(hierarchy.codesByKey).filter((code) => normalizeIcd10Key(code).startsWith(prefixKey)).sort(compareIcd10Codes);
};
/**
* Expands mixed code input into discrete codes.
* Wildcards expand via hierarchy descendants; ranges expand lexicographically
* within the same parent level; discrete codes are normalized and passed through.
*/
const expandIcd10Codes = (codes, hierarchy) => {
	const siblingsByStringParent = /* @__PURE__ */ new Map();
	for (const reference of Object.values(hierarchy.codesByKey)) {
		const parentKey = getNormalizedParentKey(reference);
		const bucket = siblingsByStringParent.get(parentKey);
		if (bucket) bucket.push(reference);
		else siblingsByStringParent.set(parentKey, [reference]);
	}
	for (const siblings of siblingsByStringParent.values()) siblings.sort(compareIcd10Codes);
	const expanded = [];
	for (const rawCode of codes) {
		const code = rawCode.trim().toUpperCase();
		if (!code) continue;
		if (code.endsWith("*")) {
			const descendants = getAllDescendants(code.replace(wildcardSuffixPattern, ""), hierarchy);
			if (descendants.length) expanded.push(...descendants);
			else expanded.push(formatWildcardFromBase(code));
			continue;
		}
		if (code.includes(rangeSeparator)) {
			const range = parseRange(code);
			if (!range) {
				expanded.push(code);
				continue;
			}
			const [startCode, endCode] = range;
			const [lowerCode, upperCode] = compareIcd10Codes(startCode, endCode) <= 0 ? [startCode, endCode] : [endCode, startCode];
			const lowerKey = normalizeIcd10Key(lowerCode);
			const upperKey = normalizeIcd10Key(upperCode);
			const lowerParent = getNormalizedParentKey(lowerCode);
			if (lowerParent !== getNormalizedParentKey(upperCode)) {
				if (normalizeIcd10Key(getParentCode(upperCode) ?? "") === lowerKey) {
					const inRange = (siblingsByStringParent.get(lowerKey) ?? []).filter((candidate) => {
						const candidateKey = normalizeIcd10Key(candidate);
						return candidateKey >= lowerKey && candidateKey <= upperKey;
					});
					if (inRange.length) {
						expanded.push(...inRange);
						continue;
					}
				}
				expanded.push(`${lowerCode}-${upperCode}`);
				continue;
			}
			const inRange = (siblingsByStringParent.get(lowerParent) ?? []).filter((candidate) => {
				const candidateKey = normalizeIcd10Key(candidate);
				return candidateKey >= lowerKey && candidateKey <= upperKey;
			});
			if (inRange.length) expanded.push(...inRange);
			else expanded.push(`${lowerCode}-${upperCode}`);
			continue;
		}
		expanded.push(formatIcd10Code(code));
	}
	return expanded;
};
/**
* Rolls up complete sibling sets to wildcard patterns (`{parent}*`) bottom-up.
* A parent is rolled up only when all of its direct children are present.
*/
const rollupToWildcards = (codes, hierarchy) => {
	const codeByKey = /* @__PURE__ */ new Map();
	for (const code of codes) {
		if (isIcd10RangeOrWildcard(code)) continue;
		const canonical = formatIcd10Code(code);
		codeByKey.set(normalizeIcd10Key(canonical), canonical);
	}
	const discreteKeys = new Set(codeByKey.keys());
	const wildcardKeys = new Set(codes.filter((code) => code.endsWith("*")).map((code) => normalizeIcd10Key(code.replace(wildcardSuffixPattern, ""))));
	const preservedRanges = codes.filter((code) => code.includes(rangeSeparator));
	const parents = Object.keys(hierarchy.childrenByParent).sort((a, b) => b.length - a.length);
	for (const parentKey of parents) {
		const children = getChildCodes(parentKey, hierarchy);
		if (!children.length) continue;
		const isCovered = (childKey) => {
			if (discreteKeys.has(childKey) || wildcardKeys.has(childKey)) return true;
			for (const wcKey of wildcardKeys) if (childKey.startsWith(wcKey)) return true;
			return false;
		};
		if (!children.every((child) => isCovered(normalizeIcd10Key(child)))) continue;
		for (const child of children) {
			const childKey = normalizeIcd10Key(child);
			discreteKeys.delete(childKey);
			wildcardKeys.delete(childKey);
		}
		wildcardKeys.add(parentKey);
	}
	const inputDerivedParents = /* @__PURE__ */ new Map();
	for (const code of codes) {
		if (isIcd10RangeOrWildcard(code)) continue;
		const parent = getParentCode(code);
		if (!parent) continue;
		const parentKey = normalizeIcd10Key(parent);
		if (hierarchy.childrenByParent[parentKey]) continue;
		const bucket = inputDerivedParents.get(parentKey) ?? [];
		bucket.push(formatIcd10Code(code));
		inputDerivedParents.set(parentKey, bucket);
	}
	for (const [parentKey, children] of inputDerivedParents.entries()) {
		if (!children.some((child) => hierarchy.codesByKey[normalizeIcd10Key(child)])) continue;
		let hasKnownAncestor = false;
		let ancestorCandidate = getParentCode(parentKey);
		while (ancestorCandidate) {
			if (hierarchy.codesByKey[normalizeIcd10Key(ancestorCandidate)]) {
				hasKnownAncestor = true;
				break;
			}
			ancestorCandidate = getParentCode(ancestorCandidate);
		}
		if (!hasKnownAncestor) continue;
		const isCovered = (childKey) => {
			if (discreteKeys.has(childKey) || wildcardKeys.has(childKey)) return true;
			for (const wcKey of wildcardKeys) if (childKey.startsWith(wcKey)) return true;
			return false;
		};
		if (!children.every((child) => isCovered(normalizeIcd10Key(child)))) continue;
		for (const child of children) {
			const childKey = normalizeIcd10Key(child);
			discreteKeys.delete(childKey);
			wildcardKeys.delete(childKey);
		}
		wildcardKeys.add(parentKey);
	}
	const absorbedWildcardKeys = /* @__PURE__ */ new Set();
	for (const key of wildcardKeys) for (const otherKey of wildcardKeys) if (key !== otherKey && key.startsWith(otherKey)) {
		absorbedWildcardKeys.add(key);
		break;
	}
	for (const key of absorbedWildcardKeys) wildcardKeys.delete(key);
	for (const wildcardKey of wildcardKeys) discreteKeys.delete(wildcardKey);
	const discrete = [...discreteKeys].map((key) => codeByKey.get(key) ?? hierarchy.codesByKey[key] ?? formatIcd10Code(key)).sort(compareIcd10Codes);
	const wildcards = [...wildcardKeys].map((key) => `${hierarchy.codesByKey[key] ?? formatIcd10Code(key)}*`).sort(compareIcd10Codes);
	return [
		...preservedRanges,
		...discrete,
		...wildcards
	].sort(compareIcd10Codes);
};
const consolidateToRangesWithMinSize = (codes, minRangeSize) => {
	const effectiveMin = Math.max(2, minRangeSize);
	const preservedRangesAndWildcards = codes.filter((code) => isIcd10RangeOrWildcard(code));
	const preservedRanges = preservedRangesAndWildcards.filter((code) => code.includes("-"));
	const preservedWildcards = preservedRangesAndWildcards.filter((code) => code.endsWith("*"));
	const discrete = codes.filter((code) => !isIcd10RangeOrWildcard(code)).map((code) => formatIcd10Code(code)).sort(compareIcd10Codes);
	const allRanges = [];
	const unpreservedRanges = [];
	for (const range of preservedRanges) {
		const match = range.match(/^([A-Z]\d+(?:\.\d+)?(?:[A-Z])?)-([A-Z]\d+(?:\.\d+)?(?:[A-Z])?)$/i);
		if (!match) {
			unpreservedRanges.push(range);
			continue;
		}
		const start = match[1];
		const end = match[2];
		const parentKey = normalizeIcd10Key(getParentCode(start) ?? "");
		if (!parentKey || getParentCode(end) !== getParentCode(start)) {
			unpreservedRanges.push(range);
			continue;
		}
		allRanges.push({
			start,
			end,
			parentKey
		});
	}
	const groupedByParent = /* @__PURE__ */ new Map();
	for (const code of discrete) {
		const parentKey = normalizeIcd10Key(getParentCode(code) ?? "");
		if (!groupedByParent.has(parentKey)) groupedByParent.set(parentKey, []);
		groupedByParent.get(parentKey).push(code);
	}
	for (const [parentKey, groupCodes] of groupedByParent.entries()) {
		const uniqueCodes = [...new Set(groupCodes)].sort(compareIcd10Codes);
		let runStart = 0;
		while (runStart < uniqueCodes.length) {
			let runEnd = runStart;
			while (runEnd + 1 < uniqueCodes.length) {
				if (!isConsecutiveSibling(normalizeDiscreteCode(uniqueCodes[runEnd]), normalizeDiscreteCode(uniqueCodes[runEnd + 1]), parentKey)) break;
				runEnd += 1;
			}
			if (runEnd - runStart + 1 >= effectiveMin) allRanges.push({
				start: uniqueCodes[runStart],
				end: uniqueCodes[runEnd],
				parentKey
			});
			runStart = runEnd + 1;
		}
	}
	const rangesByParent = /* @__PURE__ */ new Map();
	for (const range of allRanges) {
		if (!rangesByParent.has(range.parentKey)) rangesByParent.set(range.parentKey, []);
		rangesByParent.get(range.parentKey).push({
			start: range.start,
			end: range.end
		});
	}
	const finalRanges = [];
	for (const [parentKey, ranges] of rangesByParent.entries()) {
		ranges.sort((a, b) => compareIcd10Codes(a.start, b.start));
		const merged = [];
		for (const range of ranges) {
			if (merged.length === 0) {
				merged.push(range);
				continue;
			}
			const last = merged[merged.length - 1];
			const overlaps = compareIcd10Codes(range.start, last.end) <= 0;
			const adjacent = isConsecutiveSibling(normalizeDiscreteCode(last.end), normalizeDiscreteCode(range.start), parentKey);
			if (overlaps || adjacent) {
				if (compareIcd10Codes(range.end, last.end) > 0) last.end = range.end;
			} else merged.push(range);
		}
		for (const m of merged) finalRanges.push(`${m.start}-${m.end}`);
	}
	const coveredKeys = /* @__PURE__ */ new Set();
	for (const rangeStr of finalRanges) {
		const match = rangeStr.match(/^(.+)-(.+)$/);
		if (!match) continue;
		const start = match[1];
		const end = match[2];
		const parentKey = normalizeIcd10Key(getParentCode(start) ?? "");
		const parentDiscrete = groupedByParent.get(parentKey) ?? [];
		for (const code of parentDiscrete) {
			const codeNorm = normalizeDiscreteCode(code);
			const startNorm = normalizeDiscreteCode(start);
			const endNorm = normalizeDiscreteCode(end);
			if (compareIcd10Codes(codeNorm, startNorm) >= 0 && compareIcd10Codes(codeNorm, endNorm) <= 0) coveredKeys.add(normalizeIcd10Key(code));
		}
	}
	for (const wildcard of preservedWildcards) {
		const prefix = normalizeIcd10Key(wildcard.slice(0, -1));
		for (const code of discrete) if (normalizeIcd10Key(code).startsWith(prefix)) coveredKeys.add(normalizeIcd10Key(code));
	}
	const remainingDiscrete = discrete.filter((code) => !coveredKeys.has(normalizeIcd10Key(code)));
	return [
		...preservedWildcards,
		...unpreservedRanges,
		...finalRanges,
		...remainingDiscrete
	].sort(compareIcd10Codes);
};
/**
* Consolidates consecutive sibling codes into ranges.
* Existing wildcards and ranges are preserved as-is.
* Runs of 3+ consecutive siblings become `{start}-{end}`.
*/
const consolidateToRanges = (codes) => consolidateToRangesWithMinSize(codes, 3);
const isAbsorbedByOutput = (inputCode, outputCode) => {
	const canonicalInput = formatIcd10Code(inputCode.trim().toUpperCase());
	if (!canonicalInput) return false;
	const inputKey = normalizeIcd10Key(canonicalInput);
	const outputTrimmed = formatIcd10Code(outputCode.trim().toUpperCase());
	if (outputTrimmed.endsWith("*")) {
		const wildcardBase = normalizeIcd10Key(outputTrimmed.replace(wildcardSuffixPattern, ""));
		return inputKey.startsWith(wildcardBase);
	}
	if (outputTrimmed.includes(rangeSeparator)) {
		if (normalizeIcd10Key(outputTrimmed) === normalizeIcd10Key(canonicalInput)) return true;
		const range = parseRange(outputTrimmed);
		if (!range) return false;
		const [startCode, endCode] = range;
		const [lowerCode, upperCode] = compareIcd10Codes(startCode, endCode) <= 0 ? [startCode, endCode] : [endCode, startCode];
		if (getNormalizedParentKey(lowerCode) !== getNormalizedParentKey(upperCode)) return false;
		const lowerKey = normalizeIcd10Key(lowerCode);
		const upperKey = normalizeIcd10Key(upperCode);
		return inputKey >= lowerKey && inputKey <= upperKey;
	}
	return inputKey === normalizeIcd10Key(outputTrimmed);
};
/**
* Restores original range inputs when all of their expanded codes are still
* present in the consolidated output (either as discrete codes or absorbed by
* wildcards / other ranges).
*/
const restoreOriginalRanges = (output, originalRanges, hierarchy) => {
	if (originalRanges.length === 0) return output;
	const seenRanges = /* @__PURE__ */ new Set();
	const restored = [];
	const removedKeys = /* @__PURE__ */ new Set();
	for (const rangeStr of originalRanges) {
		const normalized = normalizeIcd10Key(formatIcd10Code(rangeStr));
		if (seenRanges.has(normalized)) continue;
		seenRanges.add(normalized);
		if (output.some((outCode) => normalizeIcd10Key(formatIcd10Code(outCode)) === normalized)) continue;
		const expanded = expandIcd10Codes([rangeStr], hierarchy);
		if (!expanded.every((expandedCode) => output.some((outCode) => isAbsorbedByOutput(expandedCode, outCode)))) continue;
		if (output.some((outCode) => {
			if (!outCode.endsWith("*")) return false;
			return expanded.every((expandedCode) => isAbsorbedByOutput(expandedCode, outCode));
		})) continue;
		restored.push(rangeStr);
		for (const expandedCode of expanded) removedKeys.add(normalizeIcd10Key(formatIcd10Code(expandedCode)));
	}
	return [...output.filter((code) => !removedKeys.has(normalizeIcd10Key(formatIcd10Code(code)))), ...restored];
};
const computeOutputSpecificity = (outputCode) => {
	const outputTrimmed = outputCode.trim().toUpperCase();
	if (outputTrimmed.endsWith("*")) return normalizeIcd10Key(outputTrimmed.replace(wildcardSuffixPattern, "")).length;
	if (outputTrimmed.includes(rangeSeparator)) {
		const range = parseRange(outputTrimmed);
		if (!range) return Infinity;
		const [startCode, endCode] = range;
		const [lowerKey, upperKey] = compareIcd10Codes(startCode, endCode) <= 0 ? [normalizeIcd10Key(startCode), normalizeIcd10Key(endCode)] : [normalizeIcd10Key(endCode), normalizeIcd10Key(startCode)];
		const sharedPrefixLength = getSharedPrefixLength(lowerKey, upperKey);
		if (lowerKey === upperKey) return sharedPrefixLength + 1;
		const lowerDigit = ordinalAlphabet.indexOf(lowerKey[sharedPrefixLength] ?? "");
		const upperDigit = ordinalAlphabet.indexOf(upperKey[sharedPrefixLength] ?? "");
		return sharedPrefixLength + 1 / ((lowerDigit === -1 || upperDigit === -1 ? 1 : Math.max(1, upperDigit - lowerDigit)) + 1);
	}
	return 0;
};
const selectBestOutputForInput = (inputCode, outputCodes) => {
	const candidates = outputCodes.filter((outputCode) => isAbsorbedByOutput(inputCode, outputCode));
	if (candidates.length === 0) return null;
	const inputKey = normalizeIcd10Key(inputCode);
	for (const candidate of candidates) if (normalizeIcd10Key(candidate.trim().toUpperCase()) === inputKey) return candidate;
	return candidates.reduce((best, current) => {
		const bestSpecificity = computeOutputSpecificity(best);
		return computeOutputSpecificity(current) > bestSpecificity ? current : best;
	});
};
const icd10InternalsForTesting = {
	computeOutputSpecificity,
	selectBestOutputForInput
};
/**
* Checks whether an output code is fully covered by a wildcard input.
* Used to identify consolidation artifacts that should be discarded when
* the original wildcard input could not be mapped to any output.
*/
const isOutputCoveredByWildcard = (outputCode, wildcardCode) => {
	const wildcardBase = normalizeIcd10Key(wildcardCode.replace(wildcardSuffixPattern, ""));
	const outputTrimmed = formatIcd10Code(outputCode.trim().toUpperCase());
	if (outputTrimmed.endsWith("*")) return normalizeIcd10Key(outputTrimmed.replace(wildcardSuffixPattern, "")).startsWith(wildcardBase);
	if (outputTrimmed.includes(rangeSeparator)) {
		const range = parseRange(outputTrimmed);
		if (!range) return false;
		const [startCode, endCode] = range;
		const [lowerCode, upperCode] = compareIcd10Codes(startCode, endCode) <= 0 ? [startCode, endCode] : [endCode, startCode];
		if (getNormalizedParentKey(lowerCode) !== getNormalizedParentKey(upperCode)) return false;
		const lowerKey = normalizeIcd10Key(lowerCode);
		const upperKey = normalizeIcd10Key(upperCode);
		return lowerKey.startsWith(wildcardBase) && upperKey.startsWith(wildcardBase);
	}
	return normalizeIcd10Key(outputTrimmed).startsWith(wildcardBase);
};
const buildMetadataFromInputs = (inputs) => {
	const sourceRefs = /* @__PURE__ */ new Set();
	const reasonings = /* @__PURE__ */ new Set();
	let isSecondary = false;
	let isManuallyAdded = false;
	let isSuggested = false;
	let hasActiveCode = false;
	for (const input of inputs) {
		if (input.sourceReference?.trim()) sourceRefs.add(input.sourceReference.trim());
		if (input.reasoning?.trim()) reasonings.add(input.reasoning.trim());
		if (input.isSecondary) isSecondary = true;
		if (input.isManuallyAdded) isManuallyAdded = true;
		if (input.isSuggested) isSuggested = true;
		if (!input.isRemoved) hasActiveCode = true;
	}
	return {
		isSecondary,
		isManuallyAdded,
		isSuggested,
		isRemoved: !hasActiveCode,
		sourceReference: sourceRefs.size > 0 ? [...sourceRefs].join("; ") : void 0,
		reasoning: reasonings.size > 0 ? [...reasonings].join("; ") : void 0
	};
};
/**
* Full ICD-10 consolidation pipeline, metadata-aware.
*
* Wraps `consolidateIcd10Codes` to preserve and union provenance data
* (`sourceReference`, `reasoning`, boolean flags) from absorbed inputs.
*
* - Active codes are consolidated via the full pipeline
* - Removed codes are passed through unchanged
* - Each output code absorbs metadata from all input codes it covers
*
* @param codes - Input codes with metadata
* @param referenceData - Flat list of all known ICD-10 codes (for hierarchy)
* @param config - Optional pipeline config (e.g. `minRangeSize`)
*/
const consolidateIcd10CodesWithMetadata = (codes, referenceData, config) => {
	if (!codes || codes.length === 0) return [];
	const activeCodes = codes.filter((c) => !c.isRemoved);
	const removedCodes = codes.filter((c) => c.isRemoved);
	if (activeCodes.length === 0) return removedCodes;
	const consolidatedStrings = consolidateIcd10Codes(activeCodes.map((c) => c.code), referenceData, config);
	const outputToInputsMap = /* @__PURE__ */ new Map();
	const unmappedInputs = [];
	for (const input of activeCodes) {
		const bestOutput = selectBestOutputForInput(input.code, consolidatedStrings);
		if (bestOutput) {
			if (!outputToInputsMap.has(bestOutput)) outputToInputsMap.set(bestOutput, []);
			outputToInputsMap.get(bestOutput).push(input);
		} else unmappedInputs.push(input);
	}
	const unmappedWildcards = unmappedInputs.filter((input) => input.code.endsWith("*"));
	const coveredByUnmappedWildcard = (outputCode) => unmappedWildcards.some((wc) => isOutputCoveredByWildcard(outputCode, wc.code));
	return [
		...consolidatedStrings.filter((outputCode) => outputToInputsMap.has(outputCode) || !coveredByUnmappedWildcard(outputCode)).map((outputCode) => {
			const meta = buildMetadataFromInputs(outputToInputsMap.get(outputCode) || []);
			return {
				code: outputCode,
				isRange: isIcd10RangeOrWildcard(outputCode) && !outputCode.endsWith("*"),
				...meta
			};
		}),
		...unmappedInputs,
		...removedCodes
	].sort((a, b) => compareIcd10Codes(a.code, b.code));
};
/**
* Full ICD-10 consolidation pipeline.
*
* Steps:
* 1. Build hierarchy from reference data
* 2. Expand wildcards/ranges to discrete codes
* 3. Deduplicate
* 4. Roll up complete sibling sets to wildcards
* 5. Consolidate remaining consecutive codes to ranges
* 6. Return fully sorted output
*/
const consolidateIcd10Codes = (inputCodes, referenceData, config) => {
	const hierarchy = buildIcd10Hierarchy(referenceData);
	const expanded = expandIcd10Codes(inputCodes, hierarchy);
	const originalRanges = [];
	for (const code of inputCodes) {
		if (!code.includes(rangeSeparator)) continue;
		const range = parseRange(code);
		if (!range) continue;
		const [startCode, endCode] = range;
		const [lowerCode, upperCode] = compareIcd10Codes(startCode, endCode) <= 0 ? [startCode, endCode] : [endCode, startCode];
		originalRanges.push(`${lowerCode}-${upperCode}`);
	}
	const dedupedByKey = /* @__PURE__ */ new Map();
	for (const code of expanded) {
		const trimmed = code.trim().toUpperCase();
		if (!trimmed) continue;
		if (trimmed.endsWith("*")) {
			const wildcardBase = normalizeIcd10Key(trimmed.replace(wildcardSuffixPattern, ""));
			dedupedByKey.set(`W:${wildcardBase}`, formatWildcardFromBase(trimmed));
			continue;
		}
		if (trimmed.includes(rangeSeparator)) {
			const range = parseRange(trimmed);
			if (!range) {
				dedupedByKey.set(`M:${trimmed}`, trimmed);
				continue;
			}
			const [startCode, endCode] = range;
			const [lowerCode, upperCode] = compareIcd10Codes(startCode, endCode) <= 0 ? [startCode, endCode] : [endCode, startCode];
			dedupedByKey.set(`R:${normalizeIcd10Key(lowerCode)}-${normalizeIcd10Key(upperCode)}`, `${lowerCode}-${upperCode}`);
			continue;
		}
		const canonical = formatIcd10Code(trimmed);
		dedupedByKey.set(`C:${normalizeIcd10Key(canonical)}`, canonical);
	}
	return restoreOriginalRanges(consolidateToRangesWithMinSize(rollupToWildcards([...dedupedByKey.values()], hierarchy), config?.minRangeSize ?? 3), originalRanges, hierarchy).sort(compareIcd10Codes);
};

//#endregion
//#region src/ref-data/mcd-provider-type.ts
var mcd_provider_type_exports = /* @__PURE__ */ __exportAll({
	getMedicaidState: () => getMedicaidState,
	stateCodes: () => stateCodes
});
const stateCodes = [
	"AL",
	"AK",
	"AZ",
	"AR",
	"CA",
	"CO",
	"CT",
	"DE",
	"DC",
	"FL",
	"GA",
	"HI",
	"ID",
	"IL",
	"IN",
	"IA",
	"KS",
	"KY",
	"LA",
	"ME",
	"MD",
	"MA",
	"MI",
	"MN",
	"MS",
	"MO",
	"MT",
	"NE",
	"NV",
	"NH",
	"NJ",
	"NM",
	"NY",
	"NC",
	"ND",
	"OH",
	"OK",
	"OR",
	"PA",
	"RI",
	"SC",
	"SD",
	"TN",
	"TX",
	"UT",
	"VT",
	"VA",
	"WA",
	"WV",
	"WI",
	"WY"
];
const getMedicaidState = (payorShort, connectorName) => {
	let possibleStateCode = payorShort.slice(-2);
	if (!stateCodes.includes(possibleStateCode)) possibleStateCode = connectorName?.slice(-2);
	return stateCodes.includes(possibleStateCode) ? possibleStateCode : null;
};

//#endregion
//#region src/ref-data/index.ts
const RefData = {
	...icd10_exports,
	...mcd_provider_type_exports
};

//#endregion
export { AdditionDetailsForClaimLineSchema, AdditionDetailsForClaimSchema, AdditionalIdsSchema, ArrayWithLengthSchema, CLAIM_TYPE_FLAG_KEYS, InstitutionalClaimTypes, OccurrenceCodeItemSchema, OccurrenceCodesSchema, ProfessionalClaimTypes, RefData, RialticSpecialtyCodeSchema, STALE_TIME, SailfishUrlIds, SpecialtyCodeSchema, ValueCodeItemSchema, ValueCodesSchema, ValueMoneySchema, buildAdditionalDetails, buildIcd10Hierarchy, capitalize, claimAdapter, claimTypeFlagToHiro, claimTypeFlagsShape, claimTypeLabels, claimTypeMap, claimTypeMapShort, consolidateIcd10Codes, consolidateIcd10CodesWithMetadata, consolidateToRanges, expandIcd10Codes, formatBytes, generatePolicyResponseDirectiveActionCode, getAllDescendants, getApplicableClaimTypes, getChildCodes, getClaimTypeFeatureFlags, getParentCode, getReferenceDocumentVersionExcerpt, institutionalFlags, isIcd10CodeCoveredBy, isNonNullable, isTobAndRevCodeEnabled, medicareProvSupplierDesc, orderInsightsByScore, parseNumericPolicyId, parseWsMessageAsJson, rollupToWildcards, safeJsonParse, safeJsonStringify, typeDescriptions };